import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface MessageCerclePictoProps extends pictoProps {
}

export interface MessageCerclePictoState extends pictoState {
}

export class MessageCerclePicto extends Picto<MessageCerclePictoProps,MessageCerclePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.messageCerclePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(MessageCerclePicto);
